{
    "Accessibility menu": "Меню доступності",
    "Reset settings": "Скинути налаштування",
    "Close": "Закрити",
    "Content adjustments": "Налаштування вмісту",
    "Navigation adjustments": "Налаштування навігації",
    "Align Left": "Вирівняти ліворуч",
    "Adjust Font Size": "Змінити розмір шрифту",
    "Highlight Title": "Підсвітити заголовок",
    "Highlight Links": "Підсвітити посилання",
    "Readable Font": "Легкочитабельний шрифт",
    "Colour adjustments": "Налаштування кольорів",
    "Dark Contrast": "Темна контрастність",
    "Light Contrast": "Світла контрастність",
    "High Contrast": "Висока контрастність",
    "High Saturation": "Висока насиченість",
    "Low Saturation": "Низька насиченість",
    "Monochrome": "Монохромний режим",
    "Tools": "Інструменти",
    "Reading Guide": "Лінійка для читання",
    "Stop Animations": "Зупинити анімації",
    "Big Cursor": "Великий курсор",
    "Increase Font Size": "Збільшити шрифт",
    "Decrease Font Size": "Зменшити шрифт",
    "Letter Spacing": "Міжлітерний інтервал",
    "Line Height": "Міжрядковий інтервал",
    "Font Weight": "Товщина шрифту",
    "Dyslexia Font": "Шрифт для людей із дислексією",
    "Language": "Мова",
    "Accessibility widget": "Віджет доступності",
    "Accessibility Profiles": "Профілі доступності",
    "Cognitive Disability": "Когнітивні порушення",
    "Seizure Safe": "Безпечно при епілепсії",
    "Accessibility statement": "Заява про доступність"
  }
  